import loadable from '@loadable/component'

// Implementing lazy loaded components is explained in README.md
export const LazyBreachNotificationWrapper = loadable(() =>
    import('./BreachNotificationWrapper'),
)
